import { useState } from "react";
import { Share2, Link as LinkIcon, Check } from "lucide-react";
import { toast } from "sonner";

export const FacebookIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

export const InstagramIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

export const YouTubeIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

export const TelegramIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

export const WhatsappIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c-.001 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

export const TwitterIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

export const OFFICIAL_SOCIAL_PROFILES = [
  {
    name: "Instagram",
    handle: "@lacajalgbtq",
    url: "https://www.instagram.com/lacajalgbtq",
    icon: InstagramIcon,
    bgColor: "hover:bg-[#E4405F]/20 hover:border-[#E4405F]/60 hover:text-[#E4405F]",
    badgeColor: "bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045]",
    testid: "social-link-instagram"
  },
  {
    name: "YouTube",
    handle: "@LaCajaLGBTQ",
    url: "https://www.youtube.com/@LaCajaLGBTQ",
    icon: YouTubeIcon,
    bgColor: "hover:bg-[#FF0000]/20 hover:border-[#FF0000]/60 hover:text-[#FF0000]",
    badgeColor: "bg-[#FF0000]",
    testid: "social-link-youtube"
  },
  {
    name: "Facebook",
    handle: "@lacajalgbt",
    url: "https://facebook.com/lacajalgbt",
    icon: FacebookIcon,
    bgColor: "hover:bg-[#1877F2]/20 hover:border-[#1877F2]/60 hover:text-[#1877F2]",
    badgeColor: "bg-[#1877F2]",
    testid: "social-link-facebook"
  },
  {
    name: "Telegram",
    handle: "Canal Oficial",
    url: "https://t.me/lacajalgbt",
    icon: TelegramIcon,
    bgColor: "hover:bg-[#229ED9]/20 hover:border-[#229ED9]/60 hover:text-[#229ED9]",
    badgeColor: "bg-[#229ED9]",
    testid: "social-link-telegram"
  }
];

export const SocialProfilesList = ({ className = "" }) => {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="official-social-profiles">
      {OFFICIAL_SOCIAL_PROFILES.map((p) => {
        const Icon = p.icon;
        return (
          <a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={p.testid}
            className={`flex items-center gap-2.5 px-3.5 py-2 rounded-xl bg-zinc-900/90 border border-zinc-800 text-zinc-300 text-xs font-medium transition-all duration-200 group ${p.bgColor}`}
          >
            <div className={`w-2 h-2 rounded-full ${p.badgeColor} shrink-0`} />
            <Icon className="w-4 h-4 shrink-0 transition-transform group-hover:scale-110" />
            <span className="font-semibold text-white">{p.name}</span>
            <span className="text-[10px] text-zinc-500 group-hover:text-zinc-300">{p.handle}</span>
          </a>
        );
      })}
    </div>
  );
};

export const SocialShareBar = ({ title, description, url, className = "" }) => {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(url || (typeof window !== "undefined" ? window.location.href : ""));
  const encodedText = encodeURIComponent(`Mira "${title}" en La Caja LGBT 🌈\n${description ? description.slice(0, 100) + "..." : ""}`);

  const handleCopy = () => {
    const targetUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    navigator.clipboard.writeText(targetUrl);
    setCopied(true);
    toast.success("¡Enlace copiado al portapapeles!");
    setTimeout(() => setCopied(false), 3000);
  };

  const shares = [
    {
      name: "Facebook",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      icon: FacebookIcon,
      bgColor: "hover:bg-[#1877F2]/20 text-[#1877F2] border-[#1877F2]/30",
      testid: "share-facebook"
    },
    {
      name: "Telegram",
      url: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
      icon: TelegramIcon,
      bgColor: "hover:bg-[#229ED9]/20 text-[#229ED9] border-[#229ED9]/30",
      testid: "share-telegram"
    },
    {
      name: "WhatsApp",
      url: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`,
      icon: WhatsappIcon,
      bgColor: "hover:bg-[#25D366]/20 text-[#25D366] border-[#25D366]/30",
      testid: "share-whatsapp"
    },
    {
      name: "X (Twitter)",
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}&via=lacajalgbtq`,
      icon: TwitterIcon,
      bgColor: "hover:bg-white/20 text-white border-white/30",
      testid: "share-twitter"
    }
  ];

  return (
    <div className={`flex flex-col sm:flex-row items-start sm:items-center gap-3 bg-zinc-900/60 border border-zinc-800/80 p-3.5 rounded-2xl ${className}`} data-testid="social-share-bar">
      <div className="flex items-center gap-2 text-xs font-semibold text-zinc-300 mr-2 shrink-0">
        <Share2 className="w-4 h-4 text-[#E11D48]" />
        <span>Compartir:</span>
      </div>

      <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
        {shares.map((s) => {
          const Icon = s.icon;
          return (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={s.testid}
              title={`Compartir en ${s.name}`}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border bg-black/40 text-xs font-medium transition-colors ${s.bgColor}`}
            >
              <Icon className="w-3.5 h-3.5" />
              <span className="hidden xs:inline">{s.name}</span>
            </a>
          );
        })}

        <button
          onClick={handleCopy}
          data-testid="share-copy-link"
          title="Copiar enlace"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-zinc-700/80 bg-black/40 text-xs text-zinc-300 font-medium hover:bg-zinc-800 hover:text-white transition-colors ml-auto sm:ml-0"
        >
          {copied ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <LinkIcon className="w-3.5 h-3.5" />}
          <span>{copied ? "¡Copiado!" : "Copiar Enlace"}</span>
        </button>
      </div>
    </div>
  );
};
